import { CountryIso3Code } from '@domgen/dgx-fe-i18n';

export interface CheckoutCustomerAddressDetails {
  street: string;
  number?: string;
  subBuilding?: string;
  city?: string;
  stateCode: string;
  countryCode: CountryIso3Code;
  postalCode: string;
}
